


import {IConfig} from "../models/config";
import QuestionComponent from "./views/QuestionComponent.vue";
import ResultComponent from "./views/ResultComponent.vue";
import StartComponent from "./views/StartComponent.vue";
import ExplanationComponent from "./views/ExplanationComponent.vue"
import {computed, defineComponent, onMounted, PropType} from "@vue/composition-api";
import {useStore} from "vuex-composition-helpers";

export default defineComponent({
  name: "StudyInspirator",
  components: {
    QuestionComponent,
    ResultComponent,
    StartComponent,
    ExplanationComponent
  },
  props: {
    configRaw: {type: Object as PropType<IConfig>}
  },
  setup: (props) => {
    const store = useStore()

    onMounted(() => {
      try {
        store.commit("setConfig", props.configRaw);
        store.dispatch("orderQuestions");
        store.commit("goToStart");
      } catch (error) {
        console.error(error);
      }

      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
      window.addEventListener('resize', () => {
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
      });
    })

    return {
      currentComponent: computed(() => store.state.currentComponent),
      explanationActive: computed(() => store.state.explanationActive)
    }
  }
})
